import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import StoryletCard from 'components/common/StoryletCard';

import MediaSmUp from 'components/Responsive/MediaSmUp';
import MediaXsDown from 'components/Responsive/MediaXsDown';
import { StoryletComponentProps } from 'components/Storylet/props';
import { IAppState } from 'types/app';
import StoryletBodySmUp from './components/StoryletBodySmUp';
import StoryletBodyXsDown from './components/StoryletBodyXsDown';

function Storylet(props: StoryletComponentProps & ReturnType<typeof mapStateToProps>) {
  const {
    borderColour,
    data,
    forceClearQreqs,
    isChoosing,
    isWorking,
    onCardClick,
    onChoose,
    qualityRequirements,
  } = props;

  const {
    image,
    name,
    teaser,
  } = data;

  return (
    <div className={classnames('media storylet', (isChoosing && !isWorking) && 'storylet--semi-transparent')}>
      <div className="storylet__left">
        <StoryletCard
          borderColour={borderColour}
          image={image}
          name={name}
          onClick={onCardClick}
        />
      </div>
      <MediaXsDown>
        <StoryletBodyXsDown
          data={data}
          forceClearQreqs={forceClearQreqs}
          isWorking={isWorking}
          name={name}
          onChoose={onChoose}
          qualityRequirements={qualityRequirements}
          teaser={teaser ?? ''}
        />
      </MediaXsDown>
      <MediaSmUp>
        <StoryletBodySmUp
          data={data}
          forceClearQreqs={forceClearQreqs}
          isWorking={isWorking}
          name={name}
          onChoose={onChoose}
          qualityRequirements={qualityRequirements}
          teaser={teaser ?? ''}
        />
      </MediaSmUp>
    </div>
  );
}

const mapStateToProps = ({ storylet: { isChoosing } }: IAppState) => ({ isChoosing });

export default connect(mapStateToProps)(Storylet);